import * as types from "../types/fidelidade_resumo";

const INITIAL_STATE = {
  ranking_cashback: [],
  ranking_transacoes: [],
  ranking_aniversariantes: [],
  ranking_vencimentos: [],
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FIDELIDADE_RESUMO_RANKING_CASHBACK:
      return { ...state, ranking_cashback: action.payload };
    case types.FIDELIDADE_RESUMO_RANKING_TRANSACOES:
      return { ...state, ranking_transacoes: action.payload };
    case types.FIDELIDADE_RESUMO_RANKING_ANIVERSARIANTES:
      return { ...state, ranking_aniversariantes: action.payload };
    case types.FIDELIDADE_RESUMO_RANKING_VENCIMENTOS:
      return { ...state, ranking_vencimentos: action.payload };
    case types.FIDELIDADE_RESUMO_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};
